'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _config = require('./config');

var _materials = require('./components/materials');

var _materials2 = _interopRequireDefault(_materials);

var _materialSpec = require('./components/material-spec');

var _materialSpec2 = _interopRequireDefault(_materialSpec);

var _materialShapeSpec = require('./components/material-shape-spec');

var _materialShapeSpec2 = _interopRequireDefault(_materialShapeSpec);

var _materialColorSpec = require('./components/material-color-spec');

var _materialColorSpec2 = _interopRequireDefault(_materialColorSpec);

var _materialFixmethodSpec = require('./components/material-fixmethod-spec');

var _materialFixmethodSpec2 = _interopRequireDefault(_materialFixmethodSpec);

var _materialMode = require('./components/material-mode');

var _materialMode2 = _interopRequireDefault(_materialMode);

var _materialPricing = require('./components/material-pricing');

var _materialPricing2 = _interopRequireDefault(_materialPricing);

var _products = require('./services/products.service');

var _products2 = _interopRequireDefault(_products);

var _productsDataprovider = require('./services/products.dataprovider.service');

var _productsDataprovider2 = _interopRequireDefault(_productsDataprovider);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _run = require('./run');

var _run2 = _interopRequireDefault(_run);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('products', [_angularUiRouter2.default]).component('productMaterials', _materials2.default).component('productMaterialSpec', _materialSpec2.default).component('materialShapes', _materialShapeSpec2.default).component('materialColors', _materialColorSpec2.default).component('materialFixmethods', _materialFixmethodSpec2.default).component('materialMode', _materialMode2.default).component('productMaterialPricing', _materialPricing2.default).service('ProductsService', _products2.default).service('ProductsDataProvider', _productsDataprovider2.default).config(_config.ProductsConfig).run(_run2.default).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/index.js
 **/